export default {
  isGuardsVisible: false,
  isEnvironmentVisible: false,
  isBrandingVisible: false,
  isWidgetMaterialVisible: false,
  isGenerationCrmPlan3dResultHighVisible: false,
  isCustomersVisible: false,
  isDatasetSelectionPlansVisible: false,
  isCanGetPlansToWorkVisible: false,
  isHasPanoramaCheckboxVisible: false,
  isBetaTestingCheckboxVisible: false,
  isWaitDurationVisible: false,
  isWidgetLinkConstructorVisible: false,
  isSamePlansAiVisible: false,
  isPlanDescriptionAndRendersVisible: false,
  isNewPlanOptionsVisible: false,
  isProactiveModeVisible: false,
  isPortalModeVisible: false,
  isSingleFloorCuttingVisible: false,
  isRenovationCheckboxVisible: false,
  isUnrealAdminPanelVisible: false,
  isUnrealTopDownCountVisible: false,
  isPngLosslessFormatChoiceVisible: false,
  isNinjaPlansLimitVisible: false,
  isPlanSearchVisible: true,
  isPanoramasTypeChoiceVisible: true,
  isMiddleCutHeightChoiceVisible: true,
  isCameraIsoChoiceVisible: true,
  isGltfConfigEditorVisible: false,
  isSearchButtonVisible: true,
  isGuiJsonFormVisible: true,
  isNinjaRecommendationsTabVisible: true,
  isApartmentSearchVisible: false,
  isQualityReviewPanelsVisible: false,
  isManualClientWidgetVisible: false,
  isPlan2dJpgResultVisible: false,
  isPlanRevisionsVisible: false,
};
